import { useMemo, useState } from "react"
import clsx from "clsx"

import { Table } from "components/tables/Table"

import { tableComments } from "constants/data"

import { GetSingleUser } from "services/user/type"
import { userService } from "services/user/user.service"

import { CardWrapper } from "./CardWrapper"
import { CommentsCardAddInput } from "./CommentsCardAddInput"

export enum EnumCommentsTab {
  ACCOUNT = "ACCOUNT",
  KYC = "KYC",
  GENERAL = "GENERAL"
}

type CommentsCardProps = {
  user: GetSingleUser
  onSuccess: () => void
}

export const CommentsCard = ({ user, onSuccess }: CommentsCardProps) => {
  const [commentCategory, setCommentCategory] = useState<EnumCommentsTab>(EnumCommentsTab.ACCOUNT)

  const tableFilters = useMemo(() => ({ category: commentCategory }), [commentCategory])

  const getCommentCountByCategory = (category: string) => {
    const count = user.comments.filter((item) => item.category === category).length
    return count > 100 ? "99+" : count
  }

  return (
    <CardWrapper>
      <p className="text-black dark:text-white">Notes</p>

      <div className="flex items-center pt-5">
        <div className="tabs gap-2">
          {Object.keys(EnumCommentsTab).map((tab) => (
            <a
              key={`user-tab-${tab}`}
              onClick={() => setCommentCategory(tab as EnumCommentsTab)}
              className={clsx(
                "flex cursor-pointer items-center text-left py-3 rounded-lg px-4 text-sm border text-[rgba(6,7,21,1)] dark:text-white border-[rgba(132,_0,_168,_1)] dark:border-transparent transition-all dark:bg-[#0C0C1A] hover:border-[rgba(255,255,255,0.1)]",
                {
                  "transition-all text-white bg-[rgba(132,_0,_168,_1)] dark:bg-[rgba(132,_0,_168,_1)]": commentCategory === tab,
                  "hover:border-[rgba(132,_0,_168,_0.8)] hover:dark:border-[rgba(132,_0,_168,_0.8)]  hover:bg-[rgba(169,78,206,0.2)] dark:hover:bg-[rgba(169,78,206,0.15)]":
                    commentCategory !== tab
                }
              )}
            >
              {tab} ({getCommentCountByCategory(tab)})
            </a>
          ))}
        </div>
      </div>

      <CommentsCardAddInput
        userId={user.id}
        category={commentCategory}
        onSuccess={onSuccess}
        placeholder="You can add notes to this player here"
      />

      <Table title="" handler={userService.getUserComments} filters={tableFilters} id={user.id} columns={tableComments} />
    </CardWrapper>
  )
}
